





























































import axios from 'axios'
import Vue from 'vue'
import vueDropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

export type AuthData = {
  userId: string,
  password: string,
}

export type DataType = {
  selectedCourseName: string,
  submitImage: any,
  links: any,
  submitTestLinks: any,

  isAuthed: boolean,
  authError: string,
  userId: string,
  password: string,

  isLoading: boolean,
  dropzoneOptions: any,
  vdropzoneErrors: string[],
  vdropzoneSuccessStr: string,

  submitTestLoginId: string,
  submitTestInfo: any[],
  required: any,
}
export default Vue.extend({
  components: {
    vueDropzone,
  },
  data(): DataType {
    return {
      selectedCourseName: '小1コース',
      submitImage: require('@/assets/img/top_menu13.png'),
      links: [],
      submitTestLinks: [        // account=会員ID  opId=テスト提出への会員ログイン制御用ID
        { title: '小1コース', opId: '99991231000039-aaaaaa', account: '99999999990000000039', name: 'st1' },
        { title: '小2コース', opId: '99991231000040-aaaaaa', account: '99999999990000000040', name: 'st2' },
        { title: '小3コース', opId: '99991231000041-aaaaaa', account: '99999999990000000041', name: 'st3' },
        { title: '小4コース', opId: '99991231000042-aaaaaa', account: '99999999990000000042', name: 'st4' },
        { title: '小5コース', opId: '99991231000043-aaaaaa', account: '99999999990000000043', name: 'st5' },
        { title: '小6コース', opId: '99991231000044-aaaaaa', account: '99999999990000000044', name: 'st6' },
        { title: '小1コース', opId: '99991231000045-aaaaaa', account: '99999999990000000045', name: 'st7' },
        { title: '小2コース', opId: '99991231000046-aaaaaa', account: '99999999990000000046', name: 'st8' },
        { title: '小3コース', opId: '99991231000047-aaaaaa', account: '99999999990000000047', name: 'st9' },
        { title: '小4コース', opId: '99991231000048-aaaaaa', account: '99999999990000000048', name: 'st10' },
        { title: '小5コース', opId: '99991231000049-aaaaaa', account: '99999999990000000049', name: 'st11' },
        { title: '小6コース', opId: '99991231000050-aaaaaa', account: '99999999990000000050', name: 'st12' },
        { title: '小1コース', opId: '99991231000051-aaaaaa', account: '99999999990000000051', name: 'st13' },
        { title: '小2コース', opId: '99991231000052-aaaaaa', account: '99999999990000000052', name: 'st14' },
        { title: '小3コース', opId: '99991231000053-aaaaaa', account: '99999999990000000053', name: 'st15' },
        { title: '小4コース', opId: '99991231000054-aaaaaa', account: '99999999990000000054', name: 'st16' },
        { title: '小5コース', opId: '99991231000055-aaaaaa', account: '99999999990000000055', name: 'st17' },
        { title: '小6コース', opId: '99991231000056-aaaaaa', account: '99999999990000000056', name: 'st18' },
        { title: '小1コース', opId: '99991231000057-aaaaaa', account: '99999999990000000057', name: 'st19' },
        { title: '小2コース', opId: '99991231000058-aaaaaa', account: '99999999990000000058', name: 'st20' },
        { title: '小3コース', opId: '99991231000059-aaaaaa', account: '99999999990000000059', name: 'st21' },
        { title: '小4コース', opId: '99991231000060-aaaaaa', account: '99999999990000000060', name: 'st22' },
        { title: '小5コース', opId: '99991231000061-aaaaaa', account: '99999999990000000061', name: 'st23' },
        { title: '小6コース', opId: '99991231000062-aaaaaa', account: '99999999990000000062', name: 'st24' },
        { title: '小1コース', opId: '99991231000063-aaaaaa', account: '99999999990000000063', name: 'st25' },
        { title: '小2コース', opId: '99991231000064-aaaaaa', account: '99999999990000000064', name: 'st26' },
        { title: '小3コース', opId: '99991231000065-aaaaaa', account: '99999999990000000065', name: 'st27' },
        { title: '小4コース', opId: '99991231000066-aaaaaa', account: '99999999990000000066', name: 'st28' },
        { title: '小5コース', opId: '99991231000067-aaaaaa', account: '99999999990000000067', name: 'st29' },
        { title: '小6コース', opId: '99991231000068-aaaaaa', account: '99999999990000000068', name: 'st30' },
        { title: '小1コース', opId: '99991231000069-aaaaaa', account: '99999999990000000069', name: 'st31' },
        { title: '小2コース', opId: '99991231000070-aaaaaa', account: '99999999990000000070', name: 'st32' },
        { title: '小3コース', opId: '99991231000071-aaaaaa', account: '99999999990000000071', name: 'st33' },
        { title: '小4コース', opId: '99991231000072-aaaaaa', account: '99999999990000000072', name: 'st34' },
        { title: '小5コース', opId: '99991231000073-aaaaaa', account: '99999999990000000073', name: 'st35' },
        { title: '小6コース', opId: '99991231000074-aaaaaa', account: '99999999990000000074', name: 'st36' },
        { title: '小1コース', opId: '99991231000075-aaaaaa', account: '99999999990000000075', name: 'st37' },
        { title: '小2コース', opId: '99991231000076-aaaaaa', account: '99999999990000000076', name: 'st38' },
        { title: '小3コース', opId: '99991231000077-aaaaaa', account: '99999999990000000077', name: 'st39' },
        { title: '小4コース', opId: '99991231000078-aaaaaa', account: '99999999990000000078', name: 'st40' },
        { title: '小5コース', opId: '99991231000079-aaaaaa', account: '99999999990000000079', name: 'st41' },
        { title: '小6コース', opId: '99991231000080-aaaaaa', account: '99999999990000000080', name: 'st42' },
        { title: '小1コース', opId: '99991231000081-aaaaaa', account: '99999999990000000081', name: 'st43' },
        { title: '小2コース', opId: '99991231000082-aaaaaa', account: '99999999990000000082', name: 'st44' },
        { title: '小3コース', opId: '99991231000083-aaaaaa', account: '99999999990000000083', name: 'st45' },
        { title: '小4コース', opId: '99991231000084-aaaaaa', account: '99999999990000000084', name: 'st46' },
        { title: '小5コース', opId: '99991231000085-aaaaaa', account: '99999999990000000085', name: 'st47' },
        { title: '小6コース', opId: '99991231000086-aaaaaa', account: '99999999990000000086', name: 'st48' },
        { title: '小1コース', opId: '99991231000087-aaaaaa', account: '99999999990000000087', name: 'st49' },
        { title: '小2コース', opId: '99991231000088-aaaaaa', account: '99999999990000000088', name: 'st50' },
        { title: '小3コース', opId: '99991231000089-aaaaaa', account: '99999999990000000089', name: 'st51' },
        { title: '小4コース', opId: '99991231000090-aaaaaa', account: '99999999990000000090', name: 'st52' },
        { title: '小5コース', opId: '99991231000091-aaaaaa', account: '99999999990000000091', name: 'st53' },
        { title: '小6コース', opId: '99991231000092-aaaaaa', account: '99999999990000000092', name: 'st54' },
        { title: '小1コース', opId: '99991231000093-aaaaaa', account: '99999999990000000093', name: 'st55' },
        { title: '小2コース', opId: '99991231000094-aaaaaa', account: '99999999990000000094', name: 'st56' },
        { title: '小3コース', opId: '99991231000095-aaaaaa', account: '99999999990000000095', name: 'st57' },
        { title: '小4コース', opId: '99991231000096-aaaaaa', account: '99999999990000000096', name: 'st58' },
        { title: '小5コース', opId: '99991231000097-aaaaaa', account: '99999999990000000097', name: 'st59' },
        { title: '小6コース', opId: '99991231000098-aaaaaa', account: '99999999990000000098', name: 'st60' },
        { title: '小1コース', opId: '99991231000099-aaaaaa', account: '99999999990000000099', name: 'st61' },
        { title: '小2コース', opId: '99991231000100-aaaaaa', account: '99999999990000000100', name: 'st62' },
        { title: '小3コース', opId: '99991231000101-aaaaaa', account: '99999999990000000101', name: 'st63' },
        { title: '小4コース', opId: '99991231000102-aaaaaa', account: '99999999990000000102', name: 'st64' },
        { title: '小5コース', opId: '99991231000103-aaaaaa', account: '99999999990000000103', name: 'st65' },
        { title: '小6コース', opId: '99991231000104-aaaaaa', account: '99999999990000000104', name: 'st66' },
        { title: '小1コース', opId: '99991231000105-aaaaaa', account: '99999999990000000105', name: 'st67' },
        { title: '小2コース', opId: '99991231000106-aaaaaa', account: '99999999990000000106', name: 'st68' },
        { title: '小3コース', opId: '99991231000107-aaaaaa', account: '99999999990000000107', name: 'st69' },
        { title: '小4コース', opId: '99991231000108-aaaaaa', account: '99999999990000000108', name: 'st70' },
        { title: '小5コース', opId: '99991231000109-aaaaaa', account: '99999999990000000109', name: 'st71' },
        { title: '小6コース', opId: '99991231000110-aaaaaa', account: '99999999990000000110', name: 'st72' },
        { title: '小1コース', opId: 'COMBINEDUMMY21AA', account: 'COMBINEDUMMY21AA', name: 'st73' },
        { title: '小2コース', opId: 'COMBINEDUMMY22AA', account: 'COMBINEDUMMY22AA', name: 'st74' },
        { title: '小3コース', opId: 'COMBINEDUMMY23AA', account: 'COMBINEDUMMY23AA', name: 'st75' },
        { title: '小4コース', opId: 'COMBINEDUMMY24AA', account: 'COMBINEDUMMY24AA', name: 'st76' },
        { title: '小5コース', opId: 'COMBINEDUMMY25AA', account: 'COMBINEDUMMY25AA', name: 'st77' },
        { title: '小6コース', opId: 'COMBINEDUMMY26AA', account: 'COMBINEDUMMY26AA', name: 'st78' },
      ],

      isAuthed: false,
      authError: '',
      userId: '',
      password: '',

      isLoading: false,
      dropzoneOptions: {
        url: `${process.env.VUE_APP_API_ENDPOINT}/api/v1/debug/pdf_validate`,
        method: 'post',
        acceptedFiles: '.csv',
        headers: {
          // 'My-Awesome-Header': 'header value',
          // 'access-token': this.$axios.defaults.headers.common['access-token'],
          // 'client': this.$axios.defaults.headers.common['client'],
          // 'uid': this.$axios.defaults.headers.common['uid'],
        },
        thumbnailWidth: 150,
        maxFilesize: 0.5,
        dictDefaultMessage: "<i cl,ass='mdi mdi-cloud-upload'></i>csvファイルをインポート",
      },
      vdropzoneErrors: [],
      vdropzoneSuccessStr: "",

      submitTestLoginId: '',
      submitTestInfo: [],
      required: (value: string) => !!value || '必須です',
    }
  },
  computed: {
    pdfURL() {
      return `${process.env.VUE_APP_API_ENDPOINT}/overseas_download`
    },
    manabiURL() {
      return `${process.env.VUE_APP_API_ENDPOINT}/manabi`
    },
    submitTestURL() {
      return `${process.env.VUE_APP_API_ENDPOINT}/test_submit`
    },
    isAuthDialog(): boolean {
      return !this.isAuthed
    },
  },
  methods: {
    linkFormName(linkId: string, formName: string): string {
      return linkId + formName
    },
    linkSubmitScript(linkId: string, formName: string): string {
      return "javascript:" + this.linkFormName(linkId, formName) + ".submit()"
    },
    loadAuthData(): AuthData | null {
      const authDataText = sessionStorage.getItem('debugAuth')
      if (authDataText) {
        const authData = JSON.parse(authDataText)
        return authData
      } else {
        return null
      }
    },
    saveAuthData(authData: AuthData) {
      sessionStorage.setItem('debugAuth', JSON.stringify(authData))
    },

    vdropzoneSending (file: any, xhr: any) {
      this.isLoading = true
    },
    async vdropzoneSuccess (file: any, response: any) {
      if (response.error.length) {
        this.vdropzoneErrors = response.error
        this.vdropzoneSuccessStr = ""
      } else {
        this.vdropzoneSuccessStr = "PDFアップ漏れはありませんでした。"
      }
    },
    vdropzoneComplete(){
      this.isLoading = false
    },

    // 指定したユーザのテスト情報一覧を取得
    async loadSubmitTestInfo() {
      if (!(this.$refs.submitTestResetStatusForm as any).validate()) return;
      try {
        this.submitTestInfo = []
        // この認証情報の送り方は本来会員ユーザ向けのものですが、非会員ユーザもこの方法で動きます
        const response = await axios.get(
          '/api/v1/submit/tests',
          { dataType: 'application/json', headers: { 'submit-member-id': this.submitTestLoginId } }
        )
        this.submitTestInfo = response.data?.datas
      } catch(e) {
        console.error(e)
      }
    },
    submitTestStatusText(individual_data: any) {
      if (individual_data) {
        return individual_data.status + " " + (individual_data.submit_date || '')
      } else {
        return 'null'
      }
    },
    // 指定したテストの提出状況をリセット
    async submitTestResetStatus(submitTest: any) {
      if (!(this.$refs.submitTestResetStatusForm as any).validate()) return;
      try {
        this.isLoading = true
        const examp_group_key = submitTest.exam_group_key
        const response = await axios.delete(
          `/api/v1/submit/tests/${examp_group_key}`,
          { dataType: 'application/json', headers: { 'submit-member-id': this.submitTestLoginId } }
        )
        // 一応講師サイト側の状態変化を待つ
        await this.sleep(1000)
        await this.loadSubmitTestInfo()
      } catch(e) {
        console.error(e)
      } finally {
        this.isLoading = false
      }
    },
    sleep(ms: number): Promise<void> {
      return new Promise(resolve => setTimeout(resolve, ms))
    }
  }
})
